module.exports = __webpack_public_path__ + "static/img/guizhou.a95e9aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/guizhou.png
// module id = HXor
// module chunks = 93